import React, { useEffect, useState, useCallback } from "react";
import { api } from "../../api/client";
import ConfirmModal from "../../components/ConfirmModal";
import MapPicker from "./MapPicker";

export default function CartoDAEAdmin() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [toDelete, setToDelete] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { setItems((await api.get("/admin/cartographie/dae")).items || []); }
    catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const confirmDelete = async () => {
    if (!toDelete) return;
    try {
      await api.del(`/admin/cartographie/dae/${toDelete.id}`);
      setToDelete(null); load();
    } catch (e) { alert("Erreur : " + e.message); }
  };

  const blank = { nom: "", adresse: "", acces: "", horaires: "",
                  latitude: 48.1102, longitude: 0.0815 };

  return (
    <div>
      <button onClick={() => setEditing(blank)}>+ Ajouter un défibrillateur</button>
      {loading && <p className="muted mt-2">Chargement…</p>}
      {!loading && items.length === 0 && (
        <p className="muted mt-2">Aucun défibrillateur enregistré.</p>
      )}
      {items.length > 0 && (
        <table className="admin-table mt-2"><thead><tr>
          <th>Nom</th><th>Adresse</th><th>Coordonnées</th><th>Actions</th>
        </tr></thead><tbody>
          {items.map((d) => (
            <tr key={d.id}>
              <td>{d.nom}</td>
              <td className="muted">{d.adresse}</td>
              <td className="muted" style={{ fontFamily: "monospace", fontSize: "0.85em" }}>
                {d.latitude.toFixed(5)}, {d.longitude.toFixed(5)}
              </td>
              <td>
                <button className="small" onClick={() => setEditing(d)}>Modifier</button>
                <button className="small danger" style={{ marginLeft: 6 }}
                        onClick={() => setToDelete(d)}>Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody></table>
      )}

      {editing && (
        <DAEEditor item={editing}
                   onClose={() => setEditing(null)}
                   onSaved={() => { setEditing(null); load(); }} />
      )}
      {toDelete && (
        <ConfirmModal title="Supprimer ce défibrillateur ?"
                      message={`« ${toDelete.nom} » sera définitivement supprimé.`}
                      confirmLabel="Supprimer" variant="danger"
                      onConfirm={confirmDelete} onCancel={() => setToDelete(null)} />
      )}
    </div>
  );
}

function DAEEditor({ item, onClose, onSaved }) {
  const [form, setForm] = useState(item);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    setError("");
    if (!form.nom.trim()) { setError("Le nom est obligatoire."); return; }
    setBusy(true);
    try {
      const payload = { ...form, nom: form.nom.trim() };
      if (item.id) await api.put(`/admin/cartographie/dae/${item.id}`, payload);
      else await api.post("/admin/cartographie/dae", payload);
      onSaved();
    } catch (e) { setError(e.message || "Erreur"); }
    finally { setBusy(false); }
  };

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: 920, width: "95vw" }}>
        <div className="modal-header">
          <h3>{item.id ? "Modifier le défibrillateur" : "Ajouter un défibrillateur"}</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p className="muted" style={{ fontSize: "0.85em" }}>
            Cliquez sur la carte pour positionner, ou faites glisser le marqueur.
          </p>
          <MapPicker latitude={form.latitude} longitude={form.longitude}
                     onChange={(ll) => setForm((f) => ({ ...f, ...ll }))} />
          <CoordsFields form={form} setForm={setForm} />
          <Field label="Nom" value={form.nom}
                 onChange={(v) => setForm({ ...form, nom: v })} />
          <Field label="Adresse" value={form.adresse}
                 onChange={(v) => setForm({ ...form, adresse: v })} />
          <Field label="Accès (ex : Hall mairie, façade côté rue)" value={form.acces}
                 onChange={(v) => setForm({ ...form, acces: v })} />
          <Field label="Horaires d'accès" value={form.horaires}
                 onChange={(v) => setForm({ ...form, horaires: v })}
                 placeholder="ex : 24h/24 ou heures d'ouverture mairie" />
          {error && <div className="error mt-2">{error}</div>}
        </div>
        <div className="modal-footer">
          <button className="secondary" onClick={onClose}>Annuler</button>
          <button onClick={submit} disabled={busy}>
            {busy ? "Enregistrement…" : "Enregistrer"}
          </button>
        </div>
      </div>
    </div>
  );
}

export function Field({ label, value, onChange, placeholder, type = "text" }) {
  return (
    <div className="field">
      <label>{label}</label>
      <input type={type} value={value || ""} placeholder={placeholder || ""}
             onChange={(e) => onChange(e.target.value)} />
    </div>
  );
}

export function CoordsFields({ form, setForm }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.6rem", marginTop: "0.8rem" }}>
      <div className="field"><label>Latitude</label>
        <input type="number" step="0.000001" value={form.latitude}
               onChange={(e) => setForm({ ...form, latitude: parseFloat(e.target.value) || 0 })} /></div>
      <div className="field"><label>Longitude</label>
        <input type="number" step="0.000001" value={form.longitude}
               onChange={(e) => setForm({ ...form, longitude: parseFloat(e.target.value) || 0 })} /></div>
    </div>
  );
}
